<template lang="pug">
  v-content(class="fundo")
    carousel-3d(:disable3d="true" :display="1" :width="2000" :height="600" :animationSpeed="800" :controlsVisible="true")
      slide(v-for="(slide,i) in slideimgs" :index="i" :key="i" )        
        template(slot-scope="{ index, isCurrent, leftIndex, rightIndex }")
          img(class="slideimg" :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="slide.src")
          figcaption(class="figcaption_xs" v-if="index>0" v-show="$vuetify.breakpoint.xs") LUÍS S. RODRIGUES & ASSOCIADOS
          figcaption(class="figcaption_sm" v-if="index>0" v-show="$vuetify.breakpoint.sm") LUÍS S. RODRIGUES & ASSOCIADOS
          figcaption(class="figcaption_md" v-if="index>0" v-show="$vuetify.breakpoint.md") LUÍS S. RODRIGUES & ASSOCIADOS
          figcaption(class="figcaption_lg" v-if="index>0" v-show="$vuetify.breakpoint.lg") LUÍS S. RODRIGUES & ASSOCIADOS
          figcaption(class="figcaption_lg" v-if="index>0" v-show="$vuetify.breakpoint.xl") LUÍS S. RODRIGUES & ASSOCIADOS
    v-container(fluid)
      v-layout(row wrap)
        v-flex(xs1)
        v-flex(xs4)
          v-card(flat)
            v-card-text(class="texto_titulo") </br>&nbsp&nbsp&nbsp&nbsp ÁREAS DE ATIVIDADE
            span(class="separator")
            v-list
              v-list-tile(v-for="item in areas" :key="item.id" :href="item.href" :target="item.target")
                v-list-tile-content                  
                  v-btn(flat class="menu_actividades" v-on:click="$emit('onChangeArea', item.id)") {{ item.title }}
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','contactos')") Fale connosco &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
        v-flex(xs3)
          v-card(flat class="moldura")
            v-card-text(class="texto_titulo") OS NOSSOS ADVOGADOS
            span(class="separator2")
            br
            img(:src="require('../assets/sala2.jpg')" class="imagens")
            span(class="texto1") Consulte os nossos Advogados e as localizações dos nossos escritórios.
            p </br>
            v-btn(class="botao_sm" flat v-on:click="$emit('onChangeComponent','advogados')" v-show="$vuetify.breakpoint.xs") Ver mais &nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao_sm" flat v-on:click="$emit('onChangeComponent','advogados')" v-show="$vuetify.breakpoint.sm") Ver mais &nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','advogados')" v-show="$vuetify.breakpoint.md") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','advogados')" v-show="$vuetify.breakpoint.lg") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','advogados')" v-show="$vuetify.breakpoint.xl") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
        v-flex(xs3)
          v-card(flat class="moldura")
            v-card-text(class="texto_titulo") CONTACTE-NOS
            span(class="separator2")
            br
            img(:src="require('../assets/mesa.jpg')" class="imagens")
            span(class="texto1") Entre em contacto connosco.
            p </br>
            v-btn(class="botao_sm" flat v-on:click="$emit('onChangeComponent','contactos')" v-show="$vuetify.breakpoint.xs") Ver mais &nbsp&nbsp&nbsp&nbsp >            
            v-btn(class="botao_sm" flat v-on:click="$emit('onChangeComponent','contactos')" v-show="$vuetify.breakpoint.sm") Ver mais &nbsp&nbsp&nbsp&nbsp >            
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','contactos')" v-show="$vuetify.breakpoint.md") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','contactos')" v-show="$vuetify.breakpoint.lg") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','contactos')" v-show="$vuetify.breakpoint.xl") Ver mais &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            
        v-flex(xs1)

    v-footer(class="footer")
      v-flex(xs12)
        v-layout(justify-center row wrap)
          v-layout(justify-center row wrap)
            v-btn(flat v-for="item in menu" :key="item.id" v-on:click="$emit('onChangeComponent',item.comp)" class="footerlinks") {{ item.title }}
        v-layout(justify-center row wrap)
        v-layout(justify-center row wrap)
          v-flex(xs1)
          v-flex(xs3)
            v-layout(justify-center row wrap)        
              p
              br
              p(class="texto_fundo2") </br></br></br>© 2019 Luis S. Rodrigues & Associados. All Rights Reserved.      
          v-flex(xs8)
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
  export default {
    name: 'apresentacao',
    data: () => ({
      slideimgs: [
        { src: require('../assets/sala1.jpg') },
        { src: require('../assets/sala3.jpg') },
        { src: require('../assets/maquinas.jpg') },
        { src: require('../assets/sala2.jpg') },
        { src: require('../assets/cadeiras.jpg') },        
        { src: require('../assets/corredor1.jpg') },                
        { src: require('../assets/corredor2.jpg') }
      ],
      menu: [    
        { id: '1', title: 'Apresentação', comp: 'apresentacao'},
        { id: '2', title: 'Áreas de Actividade', comp: 'areas_actividade'},
        { id: '3', title: 'Advogados', comp: 'advogados'},
        { id: '4', title: 'Contactos', comp: 'contactos'}         
      ],
      // Area: '',
      areas:[
        { id: '1', title: 'Direito Comercial', href: '', target: '_self'},
        { id: '2', title: 'Direito Fiscal', href: '', target: '_self'},
        { id: '3', title: 'Contencioso e Arbitragem', href: '', target: '_self'},
        { id: '4', title: 'Direito Laboral', href: '', target: '_self'},
        { id: '5', title: 'Direito Penal e das Contraordenações', href: '', target: '_self'},
        { id: '6', title: 'Direito Comunitário e da Concorrência', href: '', target: '_self'},
        { id: '7', title: 'Direito dos Estrangeiros', href: '', target: '_self'},
        { id: '8', title: 'Imobiliário', href: '', target: '_self'},
        { id: '9', title: 'Direito do Consumo e das Novas Tecnologias', href: '', target: '_self'},
        { id: '10', title: 'Investimento Estrangeiro', href: '', target: '_self'},
        { id: '11', title: 'Contratos', href: '', target: '_self'},
        { id: '12', title: 'Direito da Familia e Menores', href: '', target: '_self'},
        { id: '13', title: 'Direito Civil Privado', href: '', target: '_self'},
        { id: '14', title: 'Propriedade Intelectual e Industrial', href: '', target: '_self'},
        { id: '15', title: 'Bancário e Seguros', href: '', target: '_self'},
        { id: '16', title: 'Direito Falimentar e da Recuperação de Empresas', href: '', target: '_self'},
      ]
    }),

  methods: {
    // onChangeArea(area){
    //   //this.$parent.onChangeComponent(area)
    //    //this.currentView = area
    //   this.Area = area
    //   // this.currentTitle = this.areas[area-1].title
    //   // this.currentText = this.areas[area-1].text
    // },    
   },

   mounted: function () {
         this.$nextTick(function () {
            window.scrollTo(0, 0)
         })
    }

    
  }
</script>


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<style>
</style>
